<template>
  <component
    :is="tag"
    :class="[
      'rounded-theme-md border border-theme-border bg-theme-surface shadow-theme-card',
      componentClass,
    ]"
  >
    <header
      v-if="$slots.header"
      class="border-b border-theme-border px-4 py-3"
    >
      <slot name="header" :collapsed="false" />
    </header>
    <header
      v-else-if="title"
      class="flex items-center border-b border-theme-border px-4 py-3"
    >
      <p class="flex-grow text-sm font-medium text-theme-text">{{ title }}</p>
    </header>

    <div :class="['px-4 py-3', contentClass]">
      <slot />
    </div>

    <footer v-if="$slots.footer" class="border-t border-theme-border px-4 py-3">
      <slot name="footer" />
    </footer>
  </component>
</template>

<script>
  /*
   * Self-contained replacement for the legacy `@/components/CardComponent.vue`
   * the alerts-ship UI used. The redesign replaced it with `ui/data-display`
   * cards; this shim keeps the title/header/footer/default-slot API working.
   * Re-skinning onto the redesign card components is a tracked follow-up.
   */
  export default {
    name: 'CardComponent',
    props: {
      title: String,
      icon: String,
      tag: { type: String, default: 'div' },
      componentClass: { type: [String, Array, Object], default: '' },
      contentClass: { type: [String, Array, Object], default: '' },
    },
  };
</script>
